import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {Container,CssBaseline,
    Grid,Button,Paper } from '@material-ui/core';
import omit from 'lodash/omit';
// import moment from 'moment';
import { useHistory,useParams,useLocation } from 'react-router-dom';

import { AppContext } from '../../App';
import axios from '../../utils/axios';
import util from '../../utils/util';

import validate from '../../utils/validate';
import constraint from '../../Constraints/Reinvestissement';
import MyTextField from '../Codification/MyTextField';
import MyDateField from '../Codification/MyDateField';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }, 
}))
const initData = {
    date_reinvestissement:"",
    source_reinvestissement:"",
    errors:{}
};
export default function Reinvestissement(){
    const classes = useStyles();
    const history = useHistory();
    const { id } = useParams()
    const appContext = React.useContext(AppContext);
    const [reinvestissement,setReinvestissement] = React.useState({...initData})
    const [view,setView] = React.useState(false);
    const { pathname } = useLocation();
    const fetchData = async ()=>{
        appContext.setOpenLoading(true);
        try {
            if(id){
                const {data} = await axios.get(`/reinvestissements/${id}`);
                let reinvestissement = {
                        id: data.id,
                        date_reinvestissement:data.date_reinvestissement,
                        montant:data.montant,
                        description: data.description,
                        errors:{}
                    }
                if(pathname===`/reinvestir/view/${id}`){
                    setView(true);
                    reinvestissement = {
                        ...reinvestissement,
                        source_reinvestissement:data.source_reinvestissement
                    }
                }
                setReinvestissement(reinvestissement)
            }
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }
        appContext.setOpenLoading(false);
    }

    React.useEffect(()=>{
        fetchData();
        // eslint-disable-next-line
    },[]);
    const handleChange = (e)=>{
        setReinvestissement({...reinvestissement,[e.target.name]:e.target.value})
    }
    const enregistrer = async (nouveau)=>{
        const errors = validate(reinvestissement,constraint.add);
        if(errors){
            setReinvestissement({...reinvestissement,errors});
            return;
        }
        try {
            appContext.setOpenLoading(true);
            await axios.post(`/reinvestissements`,{...omit(reinvestissement,['errors','prestataire'])});
            appContext.addMessage('Enregistrement effectué avec succès','success');
            if(nouveau){
                setReinvestissement({...initData})
            }else{
                history.goBack()
            }
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }    
        appContext.setOpenLoading(false);
    }
    const modifier = async ()=>{
        const errors = validate(reinvestissement,constraint.add);
        if(errors){
            setReinvestissement({...reinvestissement,errors});
            return;
        }
        try {
            appContext.setOpenLoading(true);
            await axios.put(`/reinvestissements/${reinvestissement.id}`,{...omit(reinvestissement,['errors'])});
            appContext.addMessage('Modification effectué avec succès','success');
            history.goBack()
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }    
        appContext.setOpenLoading(false);
    }
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Paper className={classes.paper}>

                <Typography variant="h5" gutterBottom>
                    {id ? "Modification" : "Saisie"} Reinvestissement
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <MyDateField 
                            name="date_reinvestissement"
                            value={reinvestissement.date_reinvestissement||""}
                            onChange={handleChange}
                            errors={reinvestissement.errors}
                            label="Date"
                            disabled={view}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <MyTextField 
                            inputProps={{
                                min:"0",
                            }}
                            name="description"
                            value={reinvestissement.description}
                            onChange={handleChange}
                            errors={reinvestissement.errors}
                            label="Description"
                            multiline
                            rows="4"
                            variant="outlined"
                            disabled={view}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <MyTextField 
                            inputProps={{
                                min:"0",
                                style:{textAlign:'right'}
                            }}
                            name="montant"
                            type={view?"text":"number"}
                            value={view ? util.separteurMillier(reinvestissement.montant):reinvestissement.montant}
                            onChange={handleChange}
                            errors={reinvestissement.errors}
                            label="Montant du reinvestissement"
                            disabled={view}
                            // style={{}}
                        />
                    </Grid>
                    {id ?
                        <Grid item xs={12} sm={12}>
                            <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={view?history.goBack:modifier}
                            >
                                {view ?'Retour':'Modifier'}
                            </Button>
                        </Grid>
                        :
                        <Grid container>
                            <Grid item xs={6} sm={6} style={{display:'flex', justifyContent:'center'}}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={()=>enregistrer(true)}
                                >
                                    Enregistrer & Nouveau
                                </Button>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={()=>enregistrer(false)}
                                >
                                    Enregistrer & Quitter
                                </Button>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Paper>
        </Container>
    )
};